module.exports = __webpack_public_path__ + "x2.no2.1d8a0111.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/x2.no2.jpg
// module id = xZFp
// module chunks = 0